// Irish translations
export const ga: Record<string, string> = {
  'menu.dashboard': 'Painéal',
  'menu.customers': 'Custaiméirí',
  'menu.products': 'Táirgí',
  'menu.users': 'Úsáideoirí',
  'menu.settings': 'Socruithe',
  'menu.logout': 'Logáil Amach',
  'dashboard.title': 'Painéal',
  'dashboard.newOrder': 'Ordú Nua',
  'order.title': 'Ordú Nua',
  'order.customer': 'Custaiméir',
  'order.products': 'Táirgí',
  'order.total': 'Iomlán',
  'users.title': 'Úsáideoirí',
  'users.name': 'Ainm',
  'users.email': 'Ríomhphost',
  'common.yes': 'Tá',
  'common.no': 'Níl',
  'common.cancel': 'Cealaigh',
  'common.save': 'Sábháil',
  'common.search': 'Cuardaigh',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Logáil Isteach',
  'login.welcome': 'Fáilte, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Ríomhphost',
  'signup.phone': 'Fón',
  'menu.reportsAndAccounting': 'Tuarascálacha & Cuntasaíocht',
  'menu.systemAndCommunication': 'Córas & Cumarsáid',
};